import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function TotpHashAlgorithm$Companion$_anonymous__xjko1n() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.sessions.proofs.TotpHashAlgorithm', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  TotpHashAlgorithm_SHA1_instance = new (TotpHashAlgorithm())('SHA1', 0);
  TotpHashAlgorithm_SHA256_instance = new (TotpHashAlgorithm())('SHA256', 1);
  TotpHashAlgorithm_SHA512_instance = new (TotpHashAlgorithm())('SHA512', 2);
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var TotpHashAlgorithm_SHA1_instance;
var TotpHashAlgorithm_SHA256_instance;
var TotpHashAlgorithm_SHA512_instance;
function values() {
  static_init();
  return [TotpHashAlgorithm_SHA1_getInstance(), TotpHashAlgorithm_SHA256_getInstance(), TotpHashAlgorithm_SHA512_getInstance()];
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, TotpHashAlgorithm$Companion$_anonymous__xjko1n);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  static_init();
  return Companion_instance_0;
}
var TotpHashAlgorithmClass;
function TotpHashAlgorithm() {
  if (TotpHashAlgorithmClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'TotpHashAlgorithm', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    TotpHashAlgorithmClass = $;
  }
  return TotpHashAlgorithmClass;
}
function TotpHashAlgorithm_SHA1_getInstance() {
  static_init();
  return TotpHashAlgorithm_SHA1_instance;
}
function TotpHashAlgorithm_SHA256_getInstance() {
  static_init();
  return TotpHashAlgorithm_SHA256_instance;
}
function TotpHashAlgorithm_SHA512_getInstance() {
  static_init();
  return TotpHashAlgorithm_SHA512_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3fqqrg13gcz0e,
};
//endregion

//# sourceMappingURL=OtpHashAlgorithm.mjs.map
